export default "__VITE_ASSET__DwlZiL9g__"